module.exports = "<div class=\"gw-clearfix\">\n    <div class=\"span12 mb10\" ng-show=\"previous\">\n        <button class=\"gw-btn-primary\" ng-click=\"goToPrevious()\">\n            <i class=\"fa fa-chevron-left\"></i>\n            {{getPreviousLabel()}}\n        </button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/navigation/templates/back-button-navigation.html
// module id = 522
// module chunks = 0